import React from "react";

const ShortlinkStoreDetails = ({ storeName, loyaltyData, fbData }) => {
  const logoLink = loyaltyData?.logo || fbData?.logo;
  return (
    <div className="shortlink-store-details-row">
      <div
        className="store-logo-div"
        style={{
          backgroundColor: loyaltyData?.colors?.text || fbData?.colors?.text,
          border:
            logoLink?.length == 0 && loyaltyData?.colors?.text == "#FFFFFF"
              ? `1px solid ${loyaltyData?.colors?.theme}`
              : "none",
        }}
      >
        {logoLink?.length > 0 ? (
          <img
            width="100px"
            src={logoLink}
            alt="card-logo"
            title="Brand Logo"
            className="card-logo-image"
          />
        ) : (
          <p
            className="card-logo-name"
            style={{
              color: loyaltyData?.colors?.theme || fbData?.colors?.theme,
            }}
          >
            {storeName || "Reelo"}
          </p>
        )}
      </div>
      <p className="store-name">{storeName}</p>
    </div>
  );
};

export default ShortlinkStoreDetails;
